import { Inject, Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom }from '/shared/services/http.client';
import { Configuration } from './configuration';
import { Router } from '@angular/router'
import 'rxjs';

@Injectable()
export class ThemeService {
    
    public static THEMES: any = [{ id: "default", value: "Default" }, { id: "sp", value: "Green" }, { id: "tm", value: "Blue" }];

    constructor() { }

    loadTenantCSS(url: string) {
        url = url ? url : "default";
        try {
            let link: any = document.getElementById('link_theme');
            let found = false;
            // Create link
            if (!link) {
                link = document.createElement('link');
            } else {
                found = true;
            }

            link.href = 'assets/theme/' + url + ".css";
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.id = 'link_theme';

            let head = document.getElementsByTagName('head')[0];
            let links = head.getElementsByTagName('link');
            let style = head.getElementsByTagName('style')[0];

            // Check if the same style sheet has been loaded already.
            let isLoaded = false;
            for (var i = 0; i < links.length; i++) {
                var node = links[i];
                if (node.href.indexOf(link.href) > -1) {
                    isLoaded = true;
                }
            }
            if (isLoaded) return;

            if (!found) {
                head.insertBefore(link, style);
            }
        } catch (e) {
            console.error(e);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/theme-service.ts